<template>
  <div class="user-profile user-profile__wrap full-width">
    <div class="row">
      <div class="col-lg-3">
      </div>
      <div class="col-lg-6">
        <b-form @submit.prevent="handleUpdateProfile" class="info-register pt-3">     
        <div class="mt-5 mb-5">
          <div class="row">
            <div class="col-12 text-center">
              <h3 class="pt-sm-2 pb-1 mb-0 text-nowrap font-sanpro-semibold font-size-24" v-if="formModel">Chào mừng bạn đến với Hành trang số</h3>
              <p class="secondary-color-txt">Chỉ còn vài bước nữa, bạn sẽ hoàn thành hồ sơ của mình</p>
            </div>
          </div>
          <div class="row">
            <div class="col text-center mt-3">            
                  <ImageComp @get-avatar="getAvatar"/>
            </div>  
          </div>
          <div class="row mt-4">
            <div class="col-sm-12 col-md-6 col-xl-6">
              <div class="form-content">
                <label for="firstName" class="lbl-name font-size-16 font-sanpro-semibold color-form">Họ của bạn</label><br>
                <input
                  type="text" 
                  id="firstName" 
                  name="firstName"                 
                  v-model="formModel.firstName"
                  class="form-control form-30h form-bg-gray-light border-rd-10 color-form"                 
                >
                <span class="error display-block color-err font-size-14" v-if="submitted && !$v.formModel.firstName.required">Vui lòng điền họ</span>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-xl-6">
              <div class="form-content">
                <label for="lastName" class="lbl-name font-size-16 font-sanpro-semibold color-form">Tên của bạn</label><br>
                <input 
                  type="text" 
                  id="lastName" 
                  name="lastName"
                  v-model="formModel.lastName"
                  class="form-control form-30h form-bg-gray-light border-rd-10 color-form" 
                >
                <span class="error display-block color-err font-size-14" v-if="submitted && !$v.formModel.lastName.required">Vui lòng điền tên</span>
              </div>
            </div>
          </div>    
          <div class="row mt-4">
            <div class="col-sm-12 col-md-6 col-xl-6">
              <div class="form-content">
                <label for="birthday" class="lbl-name font-size-16 font-sanpro-semibold color-form">Ngày sinh của bạn</label><br>       
                <!-- <DateDropdown
                  v-model="selectedDate" 
                  months-names="Tháng 1, Tháng 2, Tháng 3, Tháng 4, Tháng 5, Tháng 6, Tháng 7, Tháng 8, Tháng 9, Tháng 10, Tháng 11, Tháng 12">
                </DateDropdown>    --> 
                <!-- {{ birthdate }}
                <pre>
                {{ formModel }}
                </pre> -->
                <DateControl min="1945" max="2020" ref="ctrlDate"
                  @input="setBirthdate"
                  :default="birthdate"
                  :dateVal="birthdate ? birthdate:''"
                  months-names="1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12"
                />          
                </div> 
              </div>
              <div class="col-sm-12 col-md-6 col-xl-6">
                <div class="form-content">
                  <label for="phone" class="lbl-name font-size-16 font-sanpro-semibold color-form">Giới tính</label><br>
                  <div class="gender-list display-flex-center justify-content-between" v-if="genderOptions">
                    <div class="item" v-for="(item, index) in genderOptions" :key="index">
                      <div class="radio-custom">
                        <input type="radio" name="radio" 
                        :checked="item.value === formModel.gender"
                         :value="item.value" @change="setGenderRegister"/>
                        <label class="color-form">{{item.text}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <div class="row mt-4">
            <div class="col-sm-12 col-md-6 col-xl-6">
              <div class="form-content">
                <label for="email" class="lbl-name font-size-16 font-sanpro-semibold color-form">Email</label><br>
                <input type="email" v-model="formModel.email" readonly class="form-control form-30h form-bg-gray-light border-rd-10 color-form"  />
                <!-- <span class="secondary-color-txt">{{ formModel.email }}</span> -->
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-xl-6">
              <div class="form-content">
                <label for="phone" class="lbl-name font-size-16 font-sanpro-semibold color-form">Số điện thoại</label><br>
                <input 
                  type="number" 
                  id="phone" 
                  name="phone"
                  v-model="formModel.phoneNumber"
                  class="form-control form-30h form-bg-gray-light border-rd-10 color-form" 
                >
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-12 col-md-6 col-xl-6">
              <!-- <div class="form-content"> -->
                <label for="city" class="lbl-name font-size-16 font-sanpro-semibold color-form">Thành phố <span class="color-err">*</span></label><br>
                <!-- <input 
                  type="text" 
                  id="city" 
                  name="city"
                  v-model="formModel.city"
                  class="form-control form-30h form-bg-gray-light border-rd-10 color-form" 
                > -->
                <!-- <span class="error display-block color-err font-size-14" v-if="submitted && !$v.formModel.city.required">Vui lòng nhập thành phố</span> -->
              <!-- </div> -->
              <div class="select-custom">
                <select
                  id="city" 
                  name="city"
                  v-model="formModel.city"
                  class="form-control form-30h form-bg-gray-light border-rd-10 color-form"
                >
                  <option value="" disabled>Chọn Thành phố</option>
                  <option v-for="(item, index) of getALLProvice" :value="item.provinceId" :key="index">
                    {{ item.name }}
                  </option>
                </select>
                <i class="fa fa-angle-down"></i>
              </div>
              <!-- {{formModel.city}}xxxxxxxxxxx -->
               <span class="error display-block color-err font-size-14" v-if="submitted && formModel.city ==0">Vui lòng chọn thành phố </span>
            </div>
            <div class="col-sm-12 col-md-6 col-xl-6">
              <div class="form-content" v-if="formModel && !formModel.roleCode || formModel.roleCode === rolePupil">
                <label for="classId" class="lbl-name font-size-16 font-sanpro-semibold color-form">Lớp <span class="color-err">*</span></label><br>
                <div class="select-custom">
                  <select 
                    id="classId" 
                    name="classId"
                    v-model="formModel.classId"
                    class="form-control form-30h form-bg-gray-light border-rd-10 color-form"
                  >
                    <option value="" disabled>Chọn lớp</option>
                    <option v-for="(item, index) of formModel.classes" :value="item.id" :key="index">{{ item.name }}</option>
                  </select>
                  <i class="fa fa-angle-down primary-color"></i>
                </div>
                <span class="error display-block color-err font-size-14" v-if="submitted && !formModel.classId || formModel.classId ==0">Vui lòng chọn lớp</span>
              </div>
              <div class="form-content" v-else>
                <label for="teacherTypeId" class="lbl-name font-size-16 font-sanpro-semibold color-form">Cấp dạy <span class="color-err">*</span></label><br>
                <div class="select-custom">
                  <select 
                    id="teacherTypeId" 
                    name="teacherTypeId"
                    v-model="formModel.teacherTypeId"
                    class="form-control form-30h form-bg-gray-light border-rd-10 color-form"
                  >
                    <option value="" disabled>Chọn Cấp dạy</option>
                    <option v-for="(item, index) in formModel.teacherTypes" :value="item.id" :key="`schoollevel_${index}`">
                      {{ item.name }}
                    </option>
                  </select>
                  <i class="fa fa-angle-down primary-color"></i>
                </div>
                <span class="error display-block color-err font-size-14" v-if="submitted && !formModel.teacherTypeId || formModel.teacherTypeId ==0">Vui lòng chọn cấp dạy</span>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-12 col-md-6 col-xl-6">
              <div class="form-content">
                <label for="school" class="lbl-name font-size-16 font-sanpro-semibold color-form">Trường <span class="color-err">*</span></label><br>
                <input 
                  type="text" 
                  id="school" 
                  name="school"
                  v-model="formModel.school"
                  class="form-control form-30h form-bg-gray-light border-rd-10 color-form" 
                >
                <span class="error display-block color-err font-size-14" v-if="submitted && !$v.formModel.school.required">Vui lòng nhập trường</span>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12 text-right">
              <!-- <router-link :to="{name: 'user-profile'}" class="primary-color font-sanpro-semibold font-size-14 mr-3">
  							Bỏ qua
  	    			</router-link> -->
              <!-- @click="handleUpdateProfile" -->
              <button type="submit" class="btn-primary-rounded btn-submit">
                Hoàn thành
              </button>
            </div>
          </div>
        </div>
        </b-form>
      </div>
      <div class="col-lg-3">
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import {STORE_KEY} from '../_store/constants'
  import moment from 'moment'
  import store from '../_store'
  import DateControl from './DateControl'
  import { getAuth, saveAuth } from '@/utils/jwt';
  import { APP_CONFIG } from '@/utils/constants'
  import  {ROLE_PUPIL}  from './../../../store/auth/constants'
  //import DateDropdown from 'vue-date-dropdown'
  import ImageComp from './Image'
  import Vuelidate from 'vuelidate'
  import { required, email } from "vuelidate/lib/validators";
  import { updateUserProfile } from '../_api'
  import router from '@/router'
  

  const genderOptions = [
    { value: 1, text: "Nam" },
    { value: 2, text: "Nữ" },
    { value: 3, text: "Khác" }
  ];

  export default {
    name: 'EditUserProfile',
    components:{
      //DateDropdown,
      DateControl,
      ImageComp
    },
    data() {
      return {
        genderOptions: genderOptions,
        rolePupil: ROLE_PUPIL,
        avatar: '',
        formModel:{},
        getALLProvice:[],
        birthdate: '',
        // formModel: {
        //   firstname:'',
        //   lastname:'',
        //   gender: genderOptions[0].value,
        //   email: '',
        //   //password: '',
        //   //confirmPassword:'',
        //  // schoolTypeId: optionsSchoolLevel[0].value,
        //   birthday:'',
        //   phone:'',
        //   teacherTypeId:'',
        //   eduDepartmentId:'',
        //   schoolId:'',
        //   //1: Hoc Sinh, 2: Giao Vien
        //   parentFullname: '',
        //   avatar:''
        // },
        submitted: false
      }
    },
    computed: {
      // ...mapGetters({
        // formModel: STORE_KEY + '/userProfileEdit',
        // getALLProvice:STORE_KEY + '/getALLProvice'
      // }),
      // birthdate() {
      //    return this.formModel && this.formModel.birthday ? moment(this.formModel.birthday).format('MM/DD/YYYY') : '';
      // }
    },
    created () {
      Promise.all([this.getInfoProfie(), this.getAllProvince()])
      
    },
    mounted() {
      // this.$refs.ctrlDate.setInitializeDate(this.birthdate);
      // this.getAllProvince();
    },
    validations() {
      let self = this;
      return {
        formModel: {
          firstName: { required },
          lastName:{ required },
          gender: {},
          birthday: {},
          // city:{ required },
          school:{ required },
          // teacherTypeId:{ required: self.formModel && self.formModel.roleCode && self.formModel.roleCode !== ROLE_PUPIL ? true : false },
          // classId:{ required:true },
          // provinceId:{ required}
        }
      }
    },
    methods:{
      moment,
      ...mapActions(STORE_KEY, ['updateUserProfile','actionGetAllProvince']),

      getInfoProfie () {
        this.$store.dispatch(STORE_KEY + '/getUserProfileEdit')
        .then(res=>{
          if (res && res.data) {
            this.formModel = res.data;
            // this.birthdate = res.data && res.data.birthday ? moment(res.data.birthday).format('MM/DD/YYYY') : ''
            // this.birthdate = res.data && res.data.birthday ? moment(new Date(res.data.birthday)).format('MM/DD/YYYY') : ''
            // this.birthdate = res.data && res.data.birthday ? moment(res.data.birthday).format('MM-dd-yyyy') : ''
            this.birthdate = res.data && res.data.birthday ? res.data.birthday : ''
            // this.$refs.ctrlDate.setInitializeDate(this.birthdate)
          }
        });
      },
      getAllProvince(){
        this.actionGetAllProvince()
        .then(res=> {
          this.getALLProvice = res.data;
        // this.formModel = res.data;

      });
      },
      setGenderRegister(evt) {
        // console.log('change', evt)
        this.formModel.gender = evt.target.value;
      },
      getAvatar (data) {
        this.formModel.avatar=data;
        this.avatar =data;
      },
      handleUpdateProfile(){
        let self = this;
        self.submitted = true;
        self.$v.$touch();
        // console.log('Form data: ', self.formModel)
        if(self.formModel && self.formModel.roleCode && self.formModel.roleCode !== ROLE_PUPIL){
            if (self.$v.$invalid ||self.$v.$invalid ||!this.formModel.teacherTypes || this.formModel.teacherTypes ==0 ||this.formModel.city== 0 ) {
                return;
            }
            self.updateUserProfile(self.formModel);
        } else {
            if (self.$v.$invalid ||!this.formModel.classId || this.formModel.classId ==0 ||this.formModel.city == 0) {
                return;
            }
            self.updateUserProfile(self.formModel);
        }
      },
      setBirthdate(val){
        this.formModel.birthday=val
      }
    }
  }
</script>
<style lang="scss" scoped>
  .avatar {
    width: 125px;
    height: 125px;
  }
  .btn-submit {
    height: 35px;
    letter-spacing: 0.03em;
  }
  @media screen and ( max-width: 991px ) {
    .user-profile__wrap {
      padding: 0 15px;
    }
  }

  @media screen and ( max-width: 767px ) {
    .row {
      >div:nth-child(2) {
        .form-content {
          margin-top: 1.2rem;
        }
      }

      &.mt-4 {
        margin-top: 0!important;
      }
    }
  }

  @media screen and ( max-width: 375px ) {
    h3 {
      font-size: 19px!important;
    }
  }
</style>